module.exports = __webpack_public_path__ + "img/logo4.37dee0e2.png";